export default "__VITE_ASSET__Dsadnwa1__"